/**
 * Investor accounts data fetching hook
 * Extracted from original lines 120-141
 */

import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import useInvestorFunds from "../../../hooks/useInvestorAccount";
import useInvestorGA from "../../../hooks/useInvestorGA";
import { InvestorAccountData } from "../StructureNote.types";

/**
 * Hook to fetch investor fund and global account data
 * Handles both SGD and USD account information
 * Original logic from lines 120-141
 *
 * @param token - Authentication token
 * @returns Account data, loading states, and refetch function
 */
export const useInvestorAccounts = (token: string) => {
  const [accountData, setAccountData] = useState<InvestorAccountData>({
    accountBalance: { SGD: 0, USD: 0 },
  });
  const [accountGAData, setAccountGAData] = useState<InvestorAccountData>({
    accountBalance: { SGD: 0, USD: 0 },
  });

  const InvestorFundsMutation = useInvestorFunds();
  const InvestorGAMutation = useInvestorGA();

  const fetchAccounts = useCallback(() => {
    // Fetch investor funds account (lines 120-130)
    InvestorFundsMutation.mutate(
      { token },
      {
        onSuccess: (data) => {
          setAccountData(data);
        },
        onError: (error: any) => {
          toast.error(error);
        },
      }
    );

    // Fetch investor GA account (lines 131-141)
    InvestorGAMutation.mutate(
      { token },
      {
        onSuccess: (data) => {
          setAccountGAData(data);
        },
        onError: (error: any) => {
          toast.error(error);
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    fetchAccounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    accountData,
    accountGAData,
    isLoading: InvestorFundsMutation.isLoading || InvestorGAMutation.isLoading,
    refetch: fetchAccounts,
  };
};
